import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import HeatingGallerySection from './components/HeatingGallerySection';
import RequestFormSection from './components/RequestFormSection';
import QuickLinksSection from './components/QuickLinksSection';
import TestimonialsSection from './components/TestimonialsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <HeatingGallerySection />
        <RequestFormSection />
        <QuickLinksSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;